import { Status } from 'generated/graphql';
import { Scope as EdgeScope, Status as EdgeStatus } from 'generated/graphql';

import { Reporting, ReportingType } from 'v2/core/entities/report';
import { Scope } from 'v2/core/entities/scope';
import { ReportSchedule } from 'v2/core/repository/edge-server/analysis/types';

export const mapFromEdgeScope = (scope: EdgeScope): Scope => {
  switch (scope) {
    case EdgeScope.Private:
      return Scope.PRIVATE;
    case EdgeScope.Public:
      return Scope.PUBLIC;
    case EdgeScope.PublicEditable:
      return Scope.PUBLIC_EDITABLE;
    case EdgeScope.Hidden:
      return Scope.HIDDEN;
    case EdgeScope.Snapshot:
      return Scope.SNAPSHOT;
    default:
      throw Error(`invalid analysis scope: ${scope}`);
  }
};

export const mapFromEdgeStatus = (scope: EdgeStatus): Status => {
  switch (scope) {
    case EdgeStatus.Invalid:
      return Status.Invalid;
    case EdgeStatus.Archived:
      return Status.Archived;
    case EdgeStatus.Unarchived:
      return Status.Unarchived;
    default:
      throw Error(`invalid analysis scope: ${scope}`);
  }
};

export const mapFromEdgeReporting = (
  reporting?: Reporting,
): ReportSchedule | undefined => {
  if (!reporting) {
    return undefined;
  }

  const feedbackSchedule = reporting.secondarySchedules?.find(
    (schedule) => schedule.reportType === ReportingType.FeedbackReport,
  );

  return feedbackSchedule;
};
